// Lib
import React, { ReactElement } from 'react';

// Utils
import { isListTypeClosestActive } from '../../../../../../common/tiptap/extensions/list/tiptapListUtils';

// Hooks
import {
    useActiveTiptapEditorTouchCallback,
    useTiptapActiveEditorSelector,
} from '../../../../../components/tiptapEditor/store/tiptapEditorStoreHooks';

// Components
import RichTextTool from './RichTextTool';

// Types
import { ToolbarToolProps } from '../../../config/toolDefinitions/toolbarToolTypes';
import { TiptapNodeType } from '../../../../../../common/tiptap/tiptapTypes';

type TiptapToggleListToolProps = ToolbarToolProps & {
    listType: TiptapNodeType;
};

const TiptapToggleListTool = (props: TiptapToggleListToolProps): ReactElement => {
    const { listType } = props;

    const isActive = useTiptapActiveEditorSelector(isListTypeClosestActive(listType));

    const toggleList = useActiveTiptapEditorTouchCallback(
        (activeEditor, event) => {
            event?.preventDefault();
            activeEditor.commands.toggleList(listType, TiptapNodeType.listItem);
        },
        [listType],
    );

    return (
        <RichTextTool
            isActive={isActive}
            onClick={toggleList}
            iconName={props.iconName || 'toolbar-numlist'}
            {...props}
        />
    );
};

export default TiptapToggleListTool;
